"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./SearchFilter.css");
var icons_1 = require("@tiendanube/icons");
var Button_1 = __importDefault(require("../Button"));
var Input_1 = __importDefault(require("../Input"));
var Text_1 = __importDefault(require("../Text"));
var Chip_1 = __importDefault(require("../Chip"));
function SearchFilter(_a) {
    var placeholder = _a.placeholder, labelButton = _a.label, filterCount = _a.filterCount, ariaLabel = _a.ariaLabel, resultCount = _a.resultCount, appliedFilters = _a.appliedFilters, rightElement = _a.rightElement, onSubmit = _a.onSubmit, onDismiss = _a.onDismiss, onClick = _a.onClick, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var _c = React.useState(""), searchValue = _c[0], setSearchValue = _c[1];
    var _d = React.useState(false), isFocused = _d[0], setFocused = _d[1];
    var handleBlur = function () {
        setFocused(false);
    };
    var handleFocus = function () {
        setFocused(true);
    };
    var handleChange = function (_a) {
        var value = _a.value;
        setSearchValue(value);
    };
    var handleSubmit = function (_a) {
        var value = _a.value;
        if (value)
            onSubmit(value);
        setSearchValue("");
        setFocused(false);
    };
    var handleDismiss = function (id) {
        onDismiss(id);
    };
    var renderFiltersButton = onClick && (React.createElement("div", { className: "nimbus--search-filters__filters" },
        React.createElement(Button_1.default, { badge: filterCount, ariaLabel: ariaLabel || labelButton, appearance: "default", icon: icons_1.SlidersIcon, onClick: onClick }, labelButton)));
    var renderFilters = appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters.map(function (_a) {
        var id = _a.id, label = _a.label;
        return (React.createElement(Chip_1.default, { key: id, id: id, label: label, onDismiss: handleDismiss }));
    });
    return (React.createElement("div", { className: "nimbus--search-filters__wrapper" },
        React.createElement("div", { className: "nimbus--search-filters" },
            React.createElement("div", { className: "nimbus--search-filters__search" },
                React.createElement(Input_1.default, { name: "search", type: "search", value: searchValue, focused: isFocused, onChange: handleChange, onSubmit: handleSubmit, onFocus: handleFocus, onBlur: handleBlur, placeholder: placeholder, maxLength: 150 })),
            renderFiltersButton),
        React.createElement("div", { className: "nimbus--search-filters__results" },
            React.createElement("div", { className: "nimbus--search-filters__results__applied" },
                resultCount && React.createElement(Text_1.default, null, resultCount),
                isLoading && React.createElement(Text_1.default.Skeleton, { width: "large" }),
                renderFilters),
            rightElement)));
}
exports.default = SearchFilter;
//# sourceMappingURL=index.js.map